<script>
  export let contents;

  const {
    title,
    subtitle,
    image: { src, alt },
    keys,
    paragraph,
  } = contents;
</script>

<style lang="scss">
  header {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-flow: column wrap;

    max-width: 800px;
    margin: 10rem auto 0 auto;
  }

  h1 {
    font-size: 3rem;
    font-weight: 100;

    text-align: center;
    color: var(--cl-ippd);

    margin: 0;
  }

  h2 {
    font-size: 2rem;
    font-weight: 100;
    color: var(--cl-ippd);
  }

  ul {
    margin: 1rem 4rem 0.5rem 4rem;
  }

  li {
    font-size: 1.8rem;
    font-weight: 400;
    margin: 1rem 0;
  }

  p {
    font-size: 1.6rem;
    font-weight: 300;
    padding: 1.5rem;
  }

  .banner {
    width: 100%;
    margin: 2.5rem 0;

    &-image {
      width: 100%;
    }
  }
</style>

<header>
  <h1>{title}</h1>
  <h2>{subtitle}</h2>
  <div class="banner">
    <img {src} {alt} class="banner-image" />
  </div>
  <ul>
    {#each keys as key}
      <li>
        {@html key}
      </li>
    {/each}
  </ul>
  <p>
    {@html paragraph}
  </p>
</header>
